// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__BUwea","label":"styles_label__8YUny","caption":"styles_caption__AGjRV","description":"styles_description__IBcNS","content":"styles_content__hVtfe"};